import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { get } from '@ember/object';
import { isPresent } from '@ember/utils';
import { task } from 'ember-concurrency';
import groupBy from 'garaje/utils/decorators/group-by';
import { dependentKeyCompat } from '@ember/object/compat';
import { filter } from 'macro-decorators';

export default class ChangelogsIndexController extends Controller {
  @service infinity;
  @service statsig;

  @tracked hasClickedLoadMore;

  @dependentKeyCompat
  get sortedLogs() {
    return this.notEmptylogs.sortBy('createdAt').reverse();
  }

  @groupBy('sortedLogs', 'day') logsByDay;
  @filter('model', (changelog) => {
    const items = get(changelog, 'items');
    // Check that items exists, is an array, and has at least one non-null item
    return (
      isPresent(items) &&
      Array.isArray(items) &&
      items.length > 0 &&
      items.some((item) => item !== null && item !== undefined)
    );
  })
  notEmptylogs;

  /*
    @param {InfinityModel} changelogs
  */
  @task
  *loadMoreLogs(changelogs) {
    yield this.infinity.infinityLoad(changelogs);
    this.hasClickedLoadMore = false;
  }
}
